module.exports = __webpack_public_path__ + "img/poetsinstructie.e7eb67af.jpg";